/**
 * Safely encodes a string to base64, handling Unicode characters correctly.
 *
 * The native `window.btoa()` function only works with ASCII characters and throws
 * an error when given Unicode/non-ASCII characters. This function works around that
 * limitation by first encoding the string as URI components, then unescaping it to
 * get a string that contains only ASCII characters, which can then be safely passed
 * to `window.btoa()`.
 *
 * @param input - The string to encode to base64, can contain any Unicode characters
 * @returns The base64 encoded string
 *
 * @example
 * // Encode a string with Unicode characters
 * const encoded = btoaSafe("Hello 世界");
 *
 * @see {@link https://stackoverflow.com/questions/23223718/failed-to-execute-btoa-on-window-the-string-to-be-encoded-contains-characte}
 */
export function btoaSafe(input: string): string {
    return window.btoa(window.unescape(window.encodeURIComponent(input)));
}
